export const FETCH_MESSAGE_COUNTER_BEGIN = "FETCH_MESSAGE_COUNTER_BEGIN";
export const FETCH_MESSAGE_COUNTER_SUCCESS = "FETCH_MESSAGE_COUNTER_SUCCESS";
export const FETCH_MESSAGE_COUNTER_FAILURE = "FETCH_MESSAGE_COUNTER_FAILURE";

export const fetchMessageCounterBegin = () => ({
    type: FETCH_MESSAGE_COUNTER_BEGIN
});

export const fetchMessageCounterSuccess = mc => {
    return {
        type: FETCH_MESSAGE_COUNTER_SUCCESS,
        payload: {messageCount: mc}
    };
};
export const fetchMessageCounterFailure = error => ({
    type: FETCH_MESSAGE_COUNTER_FAILURE,
    payload: {error}
});
